import { gql } from "@apollo/client";

/**
 * Serial-number lookup behind the dashboard quick actions (install / remove asset).
 *
 * Deliberately goes through `searchAssets` — our own installed-base index — and NOT
 * through `findAssetsBySerialNumber`: that one is an asset-registry lookup that also
 * consults external systems of record and canonicalises the serial, so it can resolve
 * to a registry row that has no installed-base presence at all (live example: serial
 * "000000000015773036" resolves to a row carrying the serial "15773036" with zero
 * locations, while the actually-installed asset sits under the padded serial).
 *
 * The index holds every live asset location, including assets parked directly under
 * their client — which is how "not installed" is represented. Whether an event is
 * possible is decided solely by the node's `availableInstalledBaseEvents`.
 *
 * `SearchStringFilter` only offers exact matching, so the serial must be typed as
 * stored — the same behaviour as the asset list's serial search.
 */
export const QuickActionAssetLookup = gql`
    query QuickActionAssetLookup($serialNumber: String!) {
        searchAssets(filter: { serialNumber: { equals: $serialNumber } }) {
            total
            searchAssetResults(pagination: { start: 0, limit: 10 }) {
                id
                asset {
                    id
                    serialNumber
                }
                assetLocation {
                    id
                    installedBaseNode {
                        id
                        availableInstalledBaseEvents
                    }
                }
            }
        }
    }
`;
